export default "__VITE_ASSET__BHpzSN1P__"